export default class AnimateSplash {

  constructor(selector, threshold = 0.5) {
    this.selector = selector
    this.threshold = threshold
    this.init()
  }

  init() {
    const splashContents = document.querySelectorAll(this.selector)
    splashContents.forEach(splashContent => this.observe(splashContent))
  }

  observe(element) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          element.classList.add('-is-splashed')
        }
      })
    }, { threshold: this.threshold })

    observer.observe(element)
  }
}
